import { AVERAGE_UNITS } from 'infrastructure/consts/average-units';
import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';

import s from './style.module.scss';
import { getAverageStatus } from '../../helpers/get-average-status';

import type { IAverage, IPatientThresholds } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface AverageItemProps {
  average: IAverage;
  thresholds?: void | IPatientThresholds;
}

const AverageItem: FC<AverageItemProps> = ({ average, thresholds }) => {
  const { name, value } = average;

  const { status, text } = getAverageStatus(average, thresholds) ?? {};
  const isValueValid = Boolean(parseInt(value));

  return (
    <div className={s.wrapper}>
      <p className={s.title} data-cy={`average-${average.name}`}>
        {name}{' '}
        {isValueValid && status === 'risk' && (
          <span
            className={s['icon-warning']}
            data-cy={`average-${average.name}-risk-icon`}
          >
            <ExclamationCircleOutlined />
          </span>
        )}
        {isValueValid && status === 'critical' && (
          <span
            className={s['icon-error']}
            data-cy={`average-${average.name}-critical-icon`}
          >
            <WarningOutlined />
          </span>
        )}
      </p>
      <div className={s.divider} />
      <div className={s['value-container']}>
        <p className={s.value} data-cy={`average-${average.name}-value`}>
          {isValueValid ? value : '-/-'}
        </p>
        <p
          className={s.measurement}
          data-cy={`average-${average.name}-measurement`}
        >
          {AVERAGE_UNITS[name]}
        </p>
      </div>
      {isValueValid && status && (
        <p
          className={s['max-value']}
          data-cy={`average-${average.name}-max-value`}
        >
          {text}
        </p>
      )}
    </div>
  );
};
export default AverageItem;
